import { classNames } from '@/shared/lib/classNames';
import cls from './Arrow.module.scss';

type Props = {
    isActive: boolean;
};

export const Arrow = ({ isActive }: Props) => {
    const color = isActive ? '#1A9E32' : '#13181BF5';

    return (
        <div className={classNames(cls.arrowContainer, { [cls.active]: isActive })}>
            <div className="s1ewkyyv svvlqhf" aria-hidden="true">
                <svg width="12" height="6" fill="none" viewBox="0 0 12 6" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fill={color}
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.8713 0.378183C10.6663 0.173158 10.3339 0.173158 10.1289 0.378183L6.0001 4.50695L1.87133 0.378183C1.6663 0.173158 1.33389 0.173158 1.12887 0.378183C0.923841 0.583208 0.923841 0.91562 1.12887 1.12065L5.62887 5.62065C5.83389 5.82567 6.1663 5.82567 6.37133 5.62065L10.8713 1.12065C11.0764 0.91562 11.0764 0.583208 10.8713 0.378183Z"
                    />
                </svg>
            </div>
        </div>
    );
};
